export default function getChartTitle(content: any, data: any) {
  if (data && data.type === 'percentileChart') {
    return getPercentileChartQuestion(content, data)
  } else {
    if (content.use_default_values && data) {
      return data.title
    }
    return content.title
  }
}

const getPercentileChartQuestion = (content: any, data: any) => {
  if (content.use_default_values && data.questionText) {
    return data.questionText
  } else {
    return content.question
  }
}
